__turbopack_context__.v({
  "cardIcon": "style-module-scss-module__h1gJqa__cardIcon",
  "cardText": "style-module-scss-module__h1gJqa__cardText",
  "cardTitle": "style-module-scss-module__h1gJqa__cardTitle",
  "component": "style-module-scss-module__h1gJqa__component",
  "description": "style-module-scss-module__h1gJqa__description",
  "heading": "style-module-scss-module__h1gJqa__heading",
  "infoCard": "style-module-scss-module__h1gJqa__infoCard",
  "infoGrid": "style-module-scss-module__h1gJqa__infoGrid",
  "tipBox": "style-module-scss-module__h1gJqa__tipBox",
  "tipHeading": "style-module-scss-module__h1gJqa__tipHeading",
  "tipText": "style-module-scss-module__h1gJqa__tipText",
});
